export const CUSTOMER_EMPTY_EMAIL = "Sin correo";
export const CUSTOMER_EMPTY_IDENTIFICATION = "Sin identificación";

// Todo o nada: si el pedido trae snapshot, se muestra solo lo que el cliente
// dio en ese pedido, sin completar con el registro de Customers. Los datos que
// no se pidieron o no se dieron no vienen en el snapshot y siguen ausentes.
export const resolveOrderCustomer = (order) => {
    if (!order) return null;
    const { customer, customerSnapshot } = order;
    if (customerSnapshot) {
        return {
            ...customerSnapshot,
            ...(customer ? { id: customer.id } : {})
        };
    }
    return customer || null;
};

export const formatCustomerIdentification = (customer) => {
    if (!customer) return "";
    const { identificationNumber, identificationType } = customer;
    if (!identificationType || !identificationNumber) return "";
    return `${String(
        identificationType
    ).toUpperCase()} ${identificationNumber}`;
};
